module.exports = __webpack_public_path__ + "img/IE-Money-logo-white.b2d89e4d.png";